export const isExpanded = (id) => ({
    type: 'IS_EXPANDED',
    id: id
});

export const isNotExpanded = () => ({
    type: 'IS_NOT_EXPANDED',
    id: ''
});

const initialState = {
    type: 'IS_NOT_EXPANDED',
    id: ''
};

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case 'IS_EXPANDED':
            return Object.assign({}, {type: action.type, id: action.id});
        case 'IS_NOT_EXPANDED':
            return Object.assign({}, {type: action.type, id: state.id});
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/state/rightMenuExpanded.js